
<!-- component that shows profile attributes at profile list -->
<template>
  <li @click="openProfile" v-bind:class="{ selected: checkActiveProfile(), deactive: !profile.active }" class="message-item flex space-between items-center border-top border-gray-5 py1 px2">
    <div class="pr2 flex-none">
      <div v-if="profile.image" class="avatar circle" width="30" height="30" :title="profile.Lastname" v-bind:style="{backgroundImage: 'url(' + profileImageURL + ')'}"></div>
      <div v-else class="avatar circle bg-gray-4"></div>
    </div>
    <div class="flex-auto h5">
      <div class="semibold">{{profileName}}{{!profile.iam.superUser ? '' : ', Pääkäyttäjä'}} </div>
      <div v-if="usersOwnProfile.iam.superAdmin">{{(companyById(profile.company) || {}).name || 'Kumppanitieto puuttuu'}}</div>
      <div>{{profile.role}}</div>
    </div>
    <div class="flex-none">
      <div v-if="profile.active" class="traffic-light" v-bind:class="{ online: profile.loggedIn }" />
      <div v-else>
        <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Lemmikkihelppi-lääkäri" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
              <g id="LemmikkiHelppi-Do--ui-admin-käyttäjähallinta" transform="translate(-311.000000, -415.000000)" stroke="#F00020">
                  <g id="Group-4" transform="translate(-1.000000, 362.000000)">
                      <g id="Group-3" transform="translate(313.000000, 54.000000)">
                          <path d="M16.2811,14.7891 C16.2811,14.1831 16.4291,13.5861 16.7151,13.0511 L18.1771,10.3041 C18.4741,9.8221 18.3231,9.1911 17.8411,8.8951 C17.3591,8.5991 16.7281,8.7501 16.4311,9.2321 L14.5731,12.1581 L15.6771,6.1341 C15.7971,5.5811 15.4451,5.0361 14.8911,4.9161 C14.3381,4.7981 13.7941,5.1491 13.6751,5.7021 L12.5241,10.7921 L12.5241,4.3041 C12.5241,3.7381 12.0651,3.2791 11.5001,3.2791 C10.9331,3.2791 10.4751,3.7381 10.4751,4.3041 L10.4751,10.7961 L9.3251,5.4551 C9.2061,4.9011 8.6611,4.5501 8.1071,4.6691 C7.5541,4.7881 7.2031,5.3331 7.3221,5.8861 L8.4271,13.5241 L6.3871,11.7431 C5.9681,11.3611 5.3201,11.3911 4.9391,11.8091 C4.5561,12.2261 4.5861,12.8741 5.0031,13.2561 L8.5941,18.0371 C9.1741,18.6431 9.9761,18.9881 10.8171,18.9881 L13.2071,18.9881 C15.6371,18.9881 16.2811,17.0931 16.2811,14.7891 L16.2811,14.7891 Z" id="Stroke-4553"></path>
                          <polygon id="Stroke-4554" stroke-linecap="round" points="6.744 23 0 16.284 0 6.831 6.744 0 16.198 0 23 6.831 23 16.284 16.198 23"></polygon>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
      </div>
    </div>
  </li>
</template>

<script>
import Util from '@/util';
import { mapGetters } from "vuex";

export default {
    name: 'ListItem',
    data() {
      return {}
    },
    props: {
      profile: {},
    },
    computed: {
      profileName() {
        return `${this.profile.lastName} ${this.profile.firstName}`.trim() || this.profile.email;
      },
      profileImageURL() {
        return Util.getProfileImageURL(this.profile.image);
      },
      ...mapGetters({
        selectedProfile: 'selectedProfile',
        usersOwnProfile: 'profile',
        companyById: 'companyById',
      }),
    },
    methods: {
      checkActiveProfile: function() {
        if(this.selectedProfile && this.selectedProfile.userId === this.profile.userId) {
          return true;
        }
        return false;
      },
      openProfile: function() {
        this.$store.dispatch('setSelectedProfile', this.profile.userId);
      },
    },
  };

</script>

<style scoped>

  .message-item {
    cursor: pointer;
  }

  .message-item:hover {
    background-color: var(--gray);
  }

  .selected {
    background-color: var(--white);
    border-top: 1px solid #00A1D4;
    box-shadow: inset 0 -1px 0 #00A1D4;
  }

  .deactive {
   
  }

  .active:hover {
    background-color: var(--white);
  }

  .avatar {
    width: 2rem;
    height: 2rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .traffic-light {
    width: var(--h5);
    height: var(--h5);
    background-color: #B4BDC1;
    border-radius: 7px;
  }

  .traffic-light.online {
    background-color: #00C76C;
  }

</style>
